/**
 * @owner @Appboy/messaging-experience
 */
import { TimeUnit } from "@lib/time";

import { messagePrioritizationDefaultRetryWindowDays } from "./defaultLimits";

/**
 * Converts a retry-window days cap into seconds for campaign/Canvas storage
 * (`retry_window_seconds`).
 *
 * @param days - Whole-day cap from the feature-limits framework
 * @returns Equivalent duration in seconds
 */
export const retryWindowDaysToSeconds = (days: number): number => {
  return days * TimeUnit.Day;
};

/**
 * Fallback default retry window cap, in seconds. Derived from
 * `messagePrioritizationDefaultRetryWindowDays` for campaign/Canvas values that are still stored
 * as seconds.
 */
export const messagePrioritizationDefaultRetryWindowSeconds = retryWindowDaysToSeconds(
  messagePrioritizationDefaultRetryWindowDays
);
